/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WbsRamoDTO
 */
export interface WbsRamoDTO {
    /**
     * 
     * @type {number}
     * @memberof WbsRamoDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WbsRamoDTO
     */
    idParent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WbsRamoDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WbsRamoDTO
     */
    posizione?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WbsRamoDTO
     */
    disabilitato?: boolean;
    /**
     * 
     * @type {Array<WbsRamoDTO>}
     * @memberof WbsRamoDTO
     */
    children?: Array<WbsRamoDTO> | null;
}

/**
 * Check if a given object implements the WbsRamoDTO interface.
 */
export function instanceOfWbsRamoDTO(value: object): value is WbsRamoDTO {
    return true;
}

export function WbsRamoDTOFromJSON(json: any): WbsRamoDTO {
    return WbsRamoDTOFromJSONTyped(json, false);
}

export function WbsRamoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WbsRamoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'idParent': json['idParent'] == null ? undefined : json['idParent'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'posizione': json['posizione'] == null ? undefined : json['posizione'],
        'disabilitato': json['disabilitato'] == null ? undefined : json['disabilitato'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(WbsRamoDTOFromJSON)),
    };
}

export function WbsRamoDTOToJSON(json: any): WbsRamoDTO {
    return WbsRamoDTOToJSONTyped(json, false);
}

export function WbsRamoDTOToJSONTyped(value?: WbsRamoDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'idParent': value['idParent'],
        'nome': value['nome'],
        'posizione': value['posizione'],
        'disabilitato': value['disabilitato'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(WbsRamoDTOToJSON)),
    };
}

